"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompareResult = void 0;
/**
 * Porównuje dane uzywając schematu, zwraca CompareResult zawierający wynik porównania i listę róźnic
 * @param firstItem pierwszy element do porównania
 * @param secondItem drugi element do porównania
 */
function compareData(schema, firstItem, secondItem, compareArraySize) {
    var result = new CompareResult();
    _compareData(schema, firstItem, secondItem, '', result, compareArraySize);
    return result;
}
exports.default = compareData;
var CompareResult = /** @class */ (function () {
    function CompareResult() {
        this.equal = true;
        this.diff = [];
    }
    return CompareResult;
}());
exports.CompareResult = CompareResult;
function _compareData(schema, firstItem, secondItem, path, result, compareArraySize) {
    if (schema.type === 'object') {
        if (typeof firstItem !== 'object') {
            firstItem = {};
        }
        if (typeof secondItem !== 'object') {
            secondItem = {};
        }
        if (schema.properties) {
            for (var key in schema.properties) {
                if (schema.properties.hasOwnProperty(key)) {
                    var element = schema.properties[key];
                    var value1 = firstItem[key];
                    var value2 = secondItem[key];
                    _compareData(element, value1, value2, path === '' ? key : path + '.' + key, result, compareArraySize);
                }
            }
        }
    }
    else if (schema.type === 'array') {
        var items = schema.items;
        if (items) {
            if (!Array.isArray(firstItem)) {
                firstItem = [];
            }
            if (!Array.isArray(secondItem)) {
                secondItem = [];
            }
            // if (Array.isArray(firstItem) && Array.isArray(secondItem)) {
            if (firstItem.length !== secondItem.length && compareArraySize) {
                result.equal = false;
                result.diff.push({
                    path: path,
                    type: 'arrayLength',
                    value: [firstItem.length, secondItem.length],
                    schema: schema
                });
            }
            var mlength = Math.max(firstItem.length, secondItem.length);
            for (var i = 0; i < mlength; i++) {
                _compareData(items, firstItem[i], secondItem[i], path + '[' + i + ']', result, compareArraySize);
            }
        }
        // }
    }
    else {
        if (firstItem === undefined && secondItem === undefined) {
            return;
        }
        if (firstItem === undefined || secondItem === undefined) {
            result.equal = false;
            result.diff.push({
                path: path,
                type: 'value',
                value: [firstItem, secondItem],
                schema: schema
            });
            return;
        }
        if ('' + firstItem !== '' + secondItem) {
            result.equal = false;
            result.diff.push({
                path: path,
                type: 'value',
                value: [firstItem, secondItem],
                schema: schema
            });
            return;
        }
    }
}
//# sourceMappingURL=compareData.js.map